import { Controller } from 'stimulus';
import { useResize } from 'stimulus-use';
import { gsap } from 'gsap';
import { getBreakpointValue } from './../tailwindhelpers';
export default class extends Controller {
  static targets = [ 'submit', 'input' ];

  connect() {
    useResize(this);
    this.submitTarget.classList.add('hidden'); 

    this.submit();

    document.addEventListener('turbo:load', this.checkBreakpoint());
  }

  resize({height, width}) {
    //this.checkBreakpoint();
  }

  submit() {
    if( /Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      this.submitTarget.click();
    } else {
      this.element.requestSubmit(); 
    }
  }

  checkBreakpoint() {
    const grid = document.querySelector('.main-content > .grid');
    if (window.innerWidth < getBreakpointValue('md')) {
      const height =  this.element.getBoundingClientRect().height; 
      document.body.style.paddingBottom = height + 'px';
    } else {
      grid.style.paddingBottom = '0px';
    } 
  }
}